import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import {
  faCheck,
  faEyeSlash,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons'
import { t } from 'i18next'

function LoginForm({
  setTenantValue = () => {},
  tenantValue,
  setEmail = () => {},
  email = '',
  showPassword = false,
  setPassword = () => {},
  password = '',
  toggleVisibility = false,
  cargando = true,
  modalState = () => {},
  error = false,
  isLoginTokenExpired,
}) {
  return (
    <>
      <div className="input-field form-group">
        <input
          type="text"
          name="tenant"
          className="form-control"
          placeholder={t('LOGIN_T.CHOOSE_ENTERPRISE_LABEL')}
          onChange={e => setTenantValue(e.target.value)}
          required
          data-testid="tenant-field"
        />
        <span
          className="tenant-validation"
          style={{
            display: tenantValue?.toLowerCase() === 'cochez' ? 'block' : 'none',
          }}>
          <FontAwesomeIcon icon={faCheck} />
        </span>
      </div>
      <div className="input-field form-group">
        <input
          type="email"
          name="email"
          className="form-control"
          placeholder={t('LOGIN_T.EMAIL_PLACEHOLDER')}
          onChange={e => setEmail(e.target.value)}
          value={email}
          required
          data-testid="email-field"
        />
      </div>
      <div className="input-field form-group">
        <input
          type={showPassword ? 'text' : 'password'}
          name="password"
          placeholder={t('LOGIN_T.PASSWORD_PLACEHOLDER')}
          className="form-control"
          onChange={e => setPassword(e.target.value)}
          value={password}
          required
          data-testid="password-field"
        />
        <span onClick={toggleVisibility} className="toggle-pass">
          <FontAwesomeIcon icon={faEyeSlash} />
        </span>
      </div>
      <button type="submit" className="btn-submit" data-testid="btn-submit">
        {cargando ? (
          <FontAwesomeIcon icon={faSpinner} className="spinner" />
        ) : (
          t('LOGIN_T.CONTINUE_BUTTON')
        )}
      </button>
      {!isLoginTokenExpired && (
        <p className="restore" data-testid="btn-restore" onClick={modalState}>
          {t('LOGIN_T.REESTABLISH_PASSWORD')}{' '}
        </p>
      )}

      {error && (
        <p className="error-message" data-testid="btn-error">
          {error}
        </p>
      )}
    </>
  )
}
export default LoginForm
